import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  FaqsListComponent,
  FaqFormComponent
} from '../upgrade/faqs.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const faqsRoutes: Routes = [
  {
    path: 'faqs',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard],
    data: {
      permission: 'faqs.view'
    },
    children: [
      {
        path: '',
        component: FaqsListComponent,
        data: {
          state: 'epf.faqs.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: FaqFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'faqs.edit',
          state: 'epf.faqs.new'
        }
      },
      {
        path: 'edit/:id',
        component: FaqFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'faqs.edit',
          state: 'epf.faqs.edit'
        }
      }
    ]
  }
];
